import { gql } from 'shared/types/layoutcreator'

export const GET_PROJECT_DOCUMENTS = gql(/* GraphQL */ `
  query getDocuments($groupId: String!, $projectId: String!) {
    projectDocuments(groupId: $groupId, projectId: $projectId) {
      id
      path
      previewUrl
      name
      type
      index
      workflowStatus
      updatedAt
    }
  }
`)

export const GET_PROJECT_DOCUMENTS_PREVIEWS = gql(/* GraphQL */ `
  query getProjectDocumentsPreviews(
    $groupId: String!
    $projectId: String!
  ) {
    getProjectDocumentsPreviews(
      groupId: $groupId
      projectId: $projectId
    ) {
      id
      path
    }
  }
`)

export const GET_PROJECT_COVER_DOCUMENTS = gql(/* GraphQL */ `
  query getProjectCoverDocuments(
    $groupId: String!
    $projectId: String!
  ) {
    findProjectCoverDocuments(
      groupId: $groupId
      projectId: $projectId
    ) {
      id
      name
      path
      previewUrl
    }
  }
`)
